<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="#004889" :loading="loading" loader-height="10">
            <v-tabs
            v-model="tab"
            background-color="primary"
            dark
            center-active
            show-arrows
            grow
            >
                <v-tab>Workorder</v-tab>
                <v-tab>Images</v-tab>
                <v-tab>Punchlist</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card flat color="#004889">
                        <v-card-text class="pa-0">
                            <ValidationObserver ref="observer1">
                                <v-form ref="jobFields">
                                    <v-list flat color="#004889" class="py-0">
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Workorder #</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.workorder_no"
                                                    solo
                                                    dark
                                                    flat
                                                    required
                                                    readonly
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Customer</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action class="align-start">
                                                <div class="d-flex align-center f-wrap">
                                                    <ValidationProvider v-slot="{ errors }" name="Customer" rules="required">
                                                        <v-autocomplete
                                                            v-model="form.customer"
                                                            :items="customers"
                                                            :loading="isLoading"
                                                            :search-input.sync="search"
                                                            hide-no-data
                                                            hide-selected
                                                            item-text="label"
                                                            item-value="value"
                                                            placeholder="Start typing to Search"
                                                            return-object
                                                            required
                                                            :error-messages="errors"
                                                            solo
                                                            flat
                                                            dark
                                                            class="customer-autocomplete"
                                                        ></v-autocomplete>
                                                    </ValidationProvider>
                                                    <v-btn
                                                        class="ml-1"
                                                        fab
                                                        dark
                                                        small
                                                        text
                                                        :to="{ name:'New Customer', params: { redirect: 'New Workorder' } }"
                                                    >
                                                        <v-icon dark>
                                                            mdi-plus
                                                        </v-icon>
                                                    </v-btn>
                                                </div>
                                                <div class="d-flex align-left mt-3">
                                                    <v-btn text class="white accent--text" tile small :to="{ name:'Customer', params:{id: form.customer.value, redirect: 'Workorder Edit', job: id} }">
                                                        Open Customer
                                                    </v-btn>
                                                </div>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Customer Phone</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.customer.object.phone"
                                                    solo
                                                    dark
                                                    flat
                                                    required
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Customer Email</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.customer.object.email"
                                                    solo
                                                    dark
                                                    flat
                                                    required
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-select
                                                    v-model="form.status"
                                                    :items="filteredStatuses"
                                                    item-text="label"
                                                    item-value="value"
                                                    required
                                                    :error-messages="errors"
                                                    solo
                                                    flat
                                                    dark
                                                ></v-select>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Payment Status</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-select
                                                    v-model="form.payment_status"
                                                    :items="paymentStatus"
                                                    item-text="label"
                                                    item-value="value"
                                                    required
                                                    :error-messages="errors"
                                                    solo
                                                    flat
                                                    dark
                                                ></v-select>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Type</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-select
                                                    v-model="form.wo_type"
                                                    :items="filteredTypes"
                                                    item-text="label"
                                                    item-value="value"
                                                    required
                                                    :error-messages="errors"
                                                    solo
                                                    flat
                                                    dark
                                                ></v-select>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Priority</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-select
                                                    v-model="form.priority"
                                                    :items="priorities"
                                                    item-text="label"
                                                    item-value="value"
                                                    required
                                                    :error-messages="errors"
                                                    solo
                                                    flat
                                                    dark
                                                ></v-select>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Start Date</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-menu
                                                    v-model="menu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="computedStartDateFormatted"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        solo
                                                        flat
                                                        dark
                                                    ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                    v-model="form.start_date"
                                                    @input="menu = false"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Follow up date</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-menu
                                                    v-model="menu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="computedFollowupDateFormatted"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        solo
                                                        flat
                                                        dark
                                                    ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                    v-model="form.follow_up_date"
                                                    @input="menu = false"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Date Serviced</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-menu
                                                    v-model="menu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="computedDateServicedFormatted"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        solo
                                                        flat
                                                        dark
                                                    ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                    v-model="form.date_serviced"
                                                    @input="menu = false"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Completed Date</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-menu
                                                    v-model="menu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="computedCompletedDateFormatted"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        solo
                                                        flat
                                                        dark
                                                    ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                    v-model="form.completed_date"
                                                    @input="menu = false"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Time Serviced</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.time_serviced"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Assignee</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-select
                                                    v-model="form.serviced_by"
                                                    :items="users"
                                                    item-text="name"
                                                    item-value="id"
                                                    clearable
                                                    @change="submit"
                                                    solo
                                                    flat
                                                    dark
                                                    hide-details
                                                    multiple
                                                ></v-select>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Quick Description</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-textarea
                                                    v-model="form.quick_description"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                ></v-textarea>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Mr Pool Comments</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-textarea
                                                    v-model="form.description"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                ></v-textarea>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Customer's Description</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-textarea
                                                    v-model="form.customer_description"
                                                    required
                                                    solo
                                                    flat
                                                    dark
                                                ></v-textarea>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        v-for="(material, index) in form.materials" :key="`repeater-${index}`"
                                                    >
                                                        <div class="repeater my-0">
                                                            <v-row>
                                                                <v-col
                                                                    cols="6"
                                                                    md="3"
                                                                >
                                                                    <v-text-field v-model="material.qty" dark type="number" label="Quantity"></v-text-field>
                                                            
                                                                </v-col>
                                                                <v-col
                                                                    cols="6"
                                                                    md="3"
                                                                >
                                                                    <v-text-field
                                                                        v-model="material.part_no"
                                                                        flat
                                                                        dark 
                                                                        hide-details
                                                                        label="Part No"
                                                                    ></v-text-field> 
                                                                </v-col>
                                                                <v-col
                                                                    cols="10"
                                                                    md="4"
                                                                >
                                                                    <v-text-field
                                                                        v-model="material.description"
                                                                        flat
                                                                        dark 
                                                                        hide-details
                                                                        label="Description"
                                                                    ></v-text-field> 
                                                                </v-col>
                                                                <v-col
                                                                    cols="2"
                                                                >
                                                                    <v-btn class="mx-2" color="secondary" fab x-small dark @click="remove(index)" v-show="index || ( !index && form.materials.length > 1)">
                                                                        <v-icon dark>mdi-minus</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </div>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        class="d-flex justify-center"
                                                    >
                                                        <v-btn large text dark @click="add">Add New Row</v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Clorine Range</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.chemical_test.clorine_range"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">PH Range</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.chemical_test.ph_range"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Alkality</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.chemical_test.alkality"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Cyanuric Range</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.chemical_test.cyanuric_range"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Calcium Range</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.chemical_test.calcium_range"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">TDS Range</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.chemical_test.tds_range"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row" v-if="userRole == 'admin' || userRole == 'foreman'">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Estimated Cost</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.estimated_cost"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row" v-if="userRole == 'admin' || userRole == 'foreman'">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Labor Total</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.labor_total"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row" v-if="userRole == 'admin' || userRole == 'foreman'">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Material Total</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.material_total"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row" v-if="userRole == 'admin' || userRole == 'foreman'">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Sales Tax</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.sales_tax"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row" v-if="userRole == 'admin' || userRole == 'foreman'">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Total Due</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-text-field
                                                    v-model="form.total_due"
                                                    solo
                                                    dark
                                                    flat
                                                    hide-details
                                                ></v-text-field> 
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-form>
                            </ValidationObserver>
                        </v-card-text> 
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn large min-width="98%" color="white accent--text"  @click="submit" :loading="loading" tile>Update</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions> 
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <Images :workorder="id" />
                </v-tab-item>
                <v-tab-item>
                    <Punchlist :workorder="id" />
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import mixin from '../../mixin/main.js'
    import authmixin from '../../mixin/auth.js'
    import Punchlist from '../../components/Workorders/Punchlist.vue'
    import Images from '../../components/Workorders/Image.vue'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin, authmixin],
        props: ['id'],
        data () {
            return {
                form: {
                    workorder_no: '',
                    customer: {
                        label: '',
                        value: '',
                        object: []
                    },
                    status: 'active',
                    payment_status: 'unpaid',
                    wo_type: 'Regular',
                    date_serviced: '',
                    start_date: '',
                    completed_date: '',
                    follow_up_date: '',
                    time_serviced: '',
                    serviced_by: [],
                    priority: 'low',
                    quick_description: '',
                    description: '',
                    customer_description: '',
                    materials: [
                        {
                            qty: 1,
                            part_no: '',
                            description: ''
                        },
                        {
                            qty: 1,
                            part_no: '',
                            description: ''
                        },
                        {
                            qty: 1,
                            part_no: '',
                            description: ''
                        },
                    ],
                    chemical_test: {
                        clorine_range: '',
                        ph_range: '',
                        alkality: '',
                        cyanuric_range: '',
                        calcium_range: '',
                        tds_range: ''
                    },
                    estimated_cost: '',
                    labor_total: '',
                    material_total: '',
                    sales_tax: '',
                    total_due: ''
                },
                search: null,
                isLoading: false,
                customers: [],
                loading: false,
                token: '',
                pageTitle: '',
                tab: null,
            }
        },
        created() {
            this.getWorkorder()
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        mounted() {
            if(this.$route.params.tab== 'images') {
                this.tab = 1
            } 
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            Punchlist,
            Images
        },
        computed: {
            ...mapGetters({
                statuses: 'data/jobStatusArray',
                priorities: 'data/priorities',
                users: 'data/wousers',
                types: 'data/wo_types',
                paymentStatus: 'data/payment_status'
            }),
            filteredStatuses() {
                return this.statuses.filter(status => {
                    return status.value != 'all'
                })
            },
            filteredTypes() {
                return this.types.filter(type => {
                    return type.value != 'all'
                })
            },
            computedDateServicedFormatted () {
                return this.formatDate(this.form.date_serviced)
            },
            computedStartDateFormatted () {
                return this.formatDate(this.form.start_date)
            },
            computedCompletedDateFormatted () {
                return this.formatDate(this.form.completed_date)
            },
            computedFollowupDateFormatted () {
                return this.formatDate(this.form.follow_up_date)
            },
        },
        watch: {
            search (val) {
                // Items have already been requested
                if (this.isLoading) return

                this.isLoading = true

                axios.get('crm/customers/search', {
                    params: {
                        keyword: val
                    }
                })
                .then(response => {
                    this.customers = response.data.customers
                    this.$nextTick()
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.isLoading = false))
            },
        },
        methods: {
            ...mapActions({
                updateWorkorder: 'data/updateWorkorder',
            }),
            getWorkorder() {
                if(this.id) {
                    this.loading = true
                    axios.get('crm/wo/get?id=' + this.id)
                        .then((response) => {
                            this.loading = false
                            this.form.workorder_no = response.data.workorder_no
                            this.form.customer = response.data.customer
                            this.form.date_serviced = response.data.date_serviced 
                            this.form.start_date = response.data.start_date
                            this.form.completed_date = response.data.completed_date
                            this.form.follow_up_date = response.data.follow_up_date
                            this.form.time_serviced = response.data.time_serviced
                            this.form.status = response.data.status
                            this.form.payment_status = response.data.payment_status
                            this.form.wo_type = response.data.wo_type
                            this.form.serviced_by = response.data.serviced_by
                            this.form.priority = response.data.priority
                            this.form.quick_description = response.data.quick_description
                            this.form.description = response.data.description
                            this.form.customer_description = response.data.customer_description
                            this.form.chemical_test = response.data.chemical_test
                            this.form.estimated_cost = response.data.estimated_cost
                            this.form.labor_total = response.data.labor_total
                            this.form.material_total = response.data.material_total
                            this.form.sales_tax = response.data.sales_tax
                            this.form.total_due = response.data.total_due
                            if(response.data.materials != null) {
                                this.form.materials = response.data.materials
                            }
                            if(this.$route.params.customer) {
                                this.form.customer.label = this.$route.params.customer.title
                                this.form.customer.value = this.$route.params.customer.id
                                this.form.customer.object = this.$route.params.customer

                                this.customers.push({...this.form.customer})
                            } else {
                                this.customers.push({...this.form.customer})
                            }
                            this.$nextTick()
                        })
                }
            },
            async submit() {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    this.$set(this.form, 'id', this.id)
                    this.updateWorkorder(this.form).then(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                    }).catch(error => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            },
            add() {
                this.form.materials.push({                         
                    qty: 1,
                    part_no: '',
                    description: ''
                });
            },
            remove(index) {
                this.form.materials.splice(index, 1);
            },
        }
    }
</script>

<style lang="sass">
.v-chip--select
    &.v-chip
        &.v-chip--clickable
            &.v-size--small
                background: #1976d2

.f-wrap
    width: 100%

    > span 
        min-width: calc(100% - 40px)

.label 
    .v-list-item__title
            white-space: inherit


.repeater
    background: #003a6f
</style>
